"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calcMapFocus;
var zoomMapping = [{
  d: 250,
  zoom: 8
}, {
  d: 150,
  zoom: 9
}, {
  d: 50,
  zoom: 10
}, {
  d: 25,
  zoom: 11
}, {
  d: 20,
  zoom: 12
}, {
  d: 10,
  zoom: 13
}, {
  d: 5,
  zoom: 15
}];
/**
 *
 * @param locations
 * @param defaultZoom
 * @param defaultCenter
 */

function calcMapFocus(locations, defaultZoom, defaultCenter) {
  var mapFocus; // we can easily return the default values if we have more than 500 farms

  if (locations.length > 500) {
    mapFocus = {
      center: defaultCenter,
      zoom: defaultZoom
    };
    return mapFocus;
  } // recalculates center of map


  var c = calcCenterByLocations(locations, defaultCenter); // checks widest distance in found locations and sets zoom level on basis of that

  var z = calcWidestDistanceByLocations(locations, defaultZoom);
  mapFocus = {
    center: c,
    zoom: z
  };
  return mapFocus;
}
/**
 *
 * @param locations
 * @param defaultCenter
 */


function calcCenterByLocations(locations, defaultCenter) {
  if (!(locations.length > 0)) {
    return defaultCenter;
  }

  var numCoords = locations.length;
  var X = 0.0;
  var Y = 0.0;
  var Z = 0.0;

  for (var i = 0; i < locations.length; i++) {
    var _lat = locations[i].location.lat * Math.PI / 180;

    var _lon = locations[i].location.lon * Math.PI / 180;

    var a = Math.cos(_lat) * Math.cos(_lon);
    var b = Math.cos(_lat) * Math.sin(_lon);
    var c = Math.sin(_lat);
    X += a;
    Y += b;
    Z += c;
  }

  X /= numCoords;
  Y /= numCoords;
  Z /= numCoords;
  var lon = Math.atan2(Y, X);
  var hyp = Math.sqrt(X * X + Y * Y);
  var lat = Math.atan2(Z, hyp); // calculates new center coordinates

  var center = {
    lat: lat * 180 / Math.PI,
    lng: lon * 180 / Math.PI
  };
  return center;
}
/**
 *
 * @param locations
 * @param defaultZoom
 */


function calcWidestDistanceByLocations(locations, defaultZoom) {
  if (!(locations.length > 0)) {
    return defaultZoom;
  }

  var lat = locations.map(function (l) {
    return l.location.lat;
  });
  var lng = locations.map(function (l) {
    return l.location.lon;
  }); //  find smallest & largest values in coordinates

  var minCoords = {
    lat: Math.min.apply(null, lat),
    lng: Math.min.apply(null, lng)
  };
  var maxCoords = {
    lat: Math.max.apply(null, lat),
    lng: Math.max.apply(null, lng)
  }; // calculate distance between those points in km

  var R = 6371; // radius of the earth in km

  var dLat = deg2rad(minCoords.lat - maxCoords.lat);
  var dLon = deg2rad(minCoords.lng - maxCoords.lng);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(minCoords.lat)) * Math.cos(deg2rad(maxCoords.lat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // distance in km
  // d could be NaN if farms are still loading, we have to return the default value

  if (isNaN(d)) {
    return defaultZoom;
  } // get closest zoom value in array by distance in km (d)


  return zoomMapping.reduce(function (a, b) {
    return Math.abs(d - a.d) < Math.abs(d - b.d) ? a : b;
  }).zoom;
}
/**
 *
 * @param deg
 */


function deg2rad(deg) {
  // convert degree to radius
  return deg * (Math.PI / 180);
}


//////////////////
// WEBPACK FOOTER
// ./client/lib/calc-map-focus/index.js
// module id = 873
// module chunks = 0